import React, { createContext, useState, useEffect } from 'react'

export const authContext = createContext({})

const loadInitialToken = () => {
  const raw = window.localStorage.getItem('authToken')
  if (!raw) return null
  try {
    const parsed = JSON.parse(raw)
    if (parsed && typeof parsed === 'object' && parsed.rawData) return parsed.rawData
    if (typeof parsed === 'string') return parsed
    return null
  } catch {
    return raw // bare JWT, no encoding
  }
}

const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({
    loading: false,
    type: window.localStorage.getItem('authType'),
    user: JSON.parse(window.localStorage.getItem('authUser')),
    data: JSON.parse(window.localStorage.getItem('authData')),
    token: loadInitialToken()
  })

  const setAuthData = (type, user, data, token) => {
    setAuth({ type, user, data, token })
  }

  const replaceToken = (token) => {
    setAuth((prev) => ({ ...prev, token }))
  }

  useEffect(() => {
    window.localStorage.setItem('authType', auth.type)
    window.localStorage.setItem('authUser', JSON.stringify(auth.user))
    window.localStorage.setItem('authData', JSON.stringify(auth.data))
    window.localStorage.setItem('authToken', JSON.stringify(auth.token))
  }, [auth.type, auth.user, auth.data, auth.token])

  return (
    <authContext.Provider value={{ auth, setAuthData, replaceToken }}>
      {children}
    </authContext.Provider>
  )
}

export default AuthProvider
